import { render, staticRenderFns } from "./ExportData.vue?vue&type=template&id=cfc9d88c"
import script from "./ExportData.vue?vue&type=script&lang=ts"
export * from "./ExportData.vue?vue&type=script&lang=ts"
import style0 from "./ExportData.vue?vue&type=style&index=0&id=cfc9d88c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports